import * as types from './mutation-types'
import {UPDATE_CURRENT_STORE} from "./mutation-types";

export default {
  [types.LOAD_STORE](state, data) {
    state.store = data
  },
  [types.LOAD_WAREHOUSES](state, data) {
    state.warehouses = data
  },

  [types.ADD_STORE](state, data) {
    state.store.push(data)  
 },

  [types.UPDATE_STORE](state, data) {
      let save = state.store.findIndex(item => item.id === data.id)
      if(save === -1) {
          state.store.push(data)
      }else {
          state.store[save] = data
      }
  },

    [types.UPDATE_CURRENT_STORE](state, data) {
        state.currentStore = data
    },

  [types.DELETE_STORE](state, id) {
    state.store.filter((item) => item.id != id)
  },
}
